export function objectWithFallback(obj, fallback) {
  return new Proxy(obj, {
    get(target, property) {
      return target[property] || fallback;
    },
  });
}
